import { elementsIds } from "../../page.constant";
import { Footer } from "./styles";

/**
 * FixedFooter component
 * This component is used to define elements to be fixed at the bottom of the page
 * @warning this component has to be wrapped by a PageWrapper component.
 */
export const FixedFooter = ({ children, ...props }) => {
  return (
    <Footer {...props} id={elementsIds.FOOTER}>
      {children}
    </Footer>
  );
};
